var map = {
	"./JodellEcology-en/index.vue": [
		38678,
		1817,
		8678
	],
	"./JodellEcology-jp/index.vue": [
		39746,
		2794,
		9746
	],
	"./JodellEcology-kr/index.vue": [
		2460,
		6933,
		2460
	],
	"./JodellEcology/index.vue": [
		90477,
		1064,
		477
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 87867;
module.exports = webpackAsyncContext;